import { createAction, props } from "@ngrx/store";

const prefix = "[Team Skills Matrix Filter]";

export const loadComponent = createAction(`${prefix} Load Component`);
export const unloadComponent = createAction(`${prefix} Unload Component`);
export const filterTeamSkillsMatrixBySkillNames = createAction(
  `${prefix} Filter Team Summary By Skill`,
  props<{ skillNames: string[] }>(),
);
export const setAmountOfSkillsToShow = createAction(
  `${prefix} Set Amount Of Skills To Show`,
  props<{ amount: number }>(),
);
